import PropTypes from 'prop-types'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled, { ThemeContext } from 'styled-components'
import { useMediaLayout } from 'use-media'

import Button from 'components/atoms/button'
import Modal from 'components/molecules/modal'
import SelectFileButton from 'components/molecules/select-file-button'
import Menu from 'components/organisms/menu'

const StyledMenu = styled(Menu)`
  div {
    position: relative;
    width: 100%;
  }

  .actual-menu {
    position: relative;
    width: 100%;
    padding: ${({ theme }) => theme.sizeByFactor(1)};
    box-shadow: none;
    right: 0;
    top: 0;
  }
`

const AddButton = styled(Button)`
  width: ${({ theme }) => theme.sizings.lvl5};
  height: ${({ theme }) => theme.sizings.lvl5};
  min-width: ${({ theme }) => theme.sizings.lvl5};
  max-width: ${({ theme }) => theme.sizings.lvl5};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  flex: none;

  > span {
    width: auto !important;
    height: auto !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  svg {
    width: ${({ theme }) => theme.sizings.lvl3};
    height: ${({ theme }) => theme.sizings.lvl3};
  }
`

const StyledSelectFileButton = styled(SelectFileButton)`
  display: none;
`

const MediaFormUploadMenu = ({
  allowedFileExtensions,
  disabled,
  existingAssetsCount,
  addButtonId,
  multiple,
  onChange,
  customCamera,
  onCameraClick,
  buttonTitle,
}) => {
  const { t } = useTranslation()
  const theme = useContext(ThemeContext)
  const isMobile = useMediaLayout({ maxWidth: theme.metrics.desktop })
  const [menuOpen, setMenuOpen] = useState(false)

  const handleOpenMenu = () => {
    setMenuOpen(true)
  }

  const handleCloseMenu = () => {
    setMenuOpen(false)
  }

  const items = []

  items.push({
    label: customCamera ? t('fromFile') : buttonTitle,
    icon: 'edit',
    disabled: disabled,
    onClick: () => {
      handleCloseMenu()
      const fileInput = document.getElementById(addButtonId)
      if (fileInput) {
        fileInput.click()
      }
    },
  })

  if (customCamera && onCameraClick) {
    items.push({
      label: t('bulkPhotos'),
      icon: 'edit',
      disabled: disabled,
      onClick: () => {
        handleCloseMenu()
        onCameraClick()
      },
    })
  }

  if (!isMobile) {
    return null
  }

  return (
    <>
      <StyledSelectFileButton
        id={addButtonId}
        multiple={multiple}
        allowedFileExtensions={allowedFileExtensions}
        onChange={onChange}
        disabled={disabled}
        existingAssetsCount={existingAssetsCount}
      />

      <AddButton
        level="standard"
        icon="add"
        onClick={handleOpenMenu}
        disabled={disabled}
        data-test-e2e="button-add-upload-mobile"
      />

      <Modal
        title={t('addFotos')}
        showCloseButton
        open={menuOpen}
        closeHandler={handleCloseMenu}
      >
        <StyledMenu variant="popup" isMenuActive={menuOpen} items={items} />
      </Modal>
    </>
  )
}

MediaFormUploadMenu.propTypes = {
  allowedFileExtensions: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  existingAssetsCount: PropTypes.number,
  addButtonId: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  onChange: PropTypes.func,
  customCamera: PropTypes.bool,
  onCameraClick: PropTypes.func,
  buttonTitle: PropTypes.string,
}

MediaFormUploadMenu.defaultProps = {
  disabled: false,
  existingAssetsCount: 0,
  multiple: true,
  onChange: null,
  customCamera: false,
  onCameraClick: null,
  buttonTitle: 'Upload',
}

export default MediaFormUploadMenu
